(function () {
  function pad2(value) {
    return String(value).padStart(2, '0');
  }

  function destroyTimer(root) {
    if (!root) return;

    if (root.timerInterval) {
      window.clearInterval(root.timerInterval);
      root.timerInterval = null;
    }

    delete root.dataset.iwAnnouncementTimerInit;
  }

  function getEndTime(storageKey, durationMs) {
    var durationKey = storageKey + '-duration';
    var storedDuration = localStorage.getItem(durationKey);
    var storedEnd = localStorage.getItem(storageKey);
    var endTime = storedEnd ? parseInt(storedEnd, 10) : NaN;

    if (!storedEnd || isNaN(endTime) || storedDuration !== String(durationMs)) {
      endTime = Date.now() + durationMs;
      localStorage.setItem(storageKey, String(endTime));
      localStorage.setItem(durationKey, String(durationMs));
    }

    return endTime;
  }

  function resetEndTime(storageKey, durationMs) {
    var endTime = Date.now() + durationMs;
    localStorage.setItem(storageKey, String(endTime));
    localStorage.setItem(storageKey + '-duration', String(durationMs));
    return endTime;
  }

  function initTimer(root) {
    if (!root || typeof localStorage === 'undefined') return;

    var durationMs = parseInt(root.dataset.durationMs, 10);
    if (!durationMs || durationMs <= 0) return;

    var storageKey = root.dataset.storageKey;
    if (!storageKey) return;

    var loopOnComplete = root.dataset.timerLoop !== 'false';

    if (root.dataset.iwAnnouncementTimerInit === 'true' && root.timerInterval) {
      return;
    }

    destroyTimer(root);
    root.dataset.iwAnnouncementTimerInit = 'true';

    var endTime = getEndTime(storageKey, durationMs);

    var daysEl = root.querySelector('[data-timer-days]');
    var hoursEl = root.querySelector('[data-timer-hours]');
    var minutesEl = root.querySelector('[data-timer-minutes]');
    var secondsEl = root.querySelector('[data-timer-seconds]');
    var timerEl = root.querySelector('[data-iw-announcement-timer-display]');

    function tick() {
      var diff = endTime - Date.now();

      if (diff <= 0) {
        if (loopOnComplete) {
          endTime = resetEndTime(storageKey, durationMs);
          diff = endTime - Date.now();
        } else {
          diff = 0;
        }
      }

      var remaining = Math.max(diff, 0);
      var days = Math.floor(remaining / 86400000);
      var afterDays = remaining % 86400000;
      var hours = Math.floor(afterDays / 3600000);
      var afterHours = afterDays % 3600000;
      var minutes = Math.floor(afterHours / 60000);
      var seconds = Math.floor((afterHours % 60000) / 1000);

      if (!hoursEl) {
        if (daysEl) {
          minutes = Math.floor(afterDays / 60000);
          seconds = Math.floor((afterDays % 60000) / 1000);
        } else {
          minutes = Math.floor(remaining / 60000);
          seconds = Math.floor((remaining % 60000) / 1000);
        }
        hours = 0;
      }

      if (daysEl) daysEl.textContent = pad2(days);
      if (hoursEl) hoursEl.textContent = pad2(hours);
      if (minutesEl) minutesEl.textContent = pad2(minutes);
      if (secondsEl) secondsEl.textContent = pad2(seconds);

      if (timerEl) {
        var parts = [];
        if (daysEl) parts.push(days + ' days');
        if (hoursEl) parts.push(hours + ' hours');
        parts.push(minutes + ' minutes', seconds + ' seconds');
        timerEl.setAttribute('aria-label', parts.join(', ') + ' remaining');
      }
    }

    tick();
    root.timerInterval = window.setInterval(tick, 1000);
  }

  function initAll(container) {
    (container || document).querySelectorAll('[data-iw-announcement-timer]').forEach(initTimer);
  }

  window.initIwAnnouncementTimers = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
